// Навигация с переключением
export function activeNavStep (step, navStepId)
{
    const steps = BX(navStepId).querySelectorAll('.fr_step_wrapper')

    steps.forEach((div) =>
    {
        if (Number(div.dataset.step) < step) {
            div.classList.add('off');
            div.classList.remove('active');
        } else if (Number(div.dataset.step) === step) {
            div.classList.add('active');
            div.classList.remove('off');
        } else if (Number(div.dataset.step) > step) {
            div.classList.remove('off');
            div.classList.remove('active');
        }
    })
}